export default "__VITE_ASSET__BsCABSRO__"